import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './lifePavilion.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { LifePavilion } from "model/dealerStore/lifePavilion.model";

export interface LevelDetailsProps extends DetailsStateAndDispatchProps<LifePavilion,'storeLable'>,
  RouteComponentProps, StateProps, DispatchProps {
}
const LifePavilionDetails: FC<LevelDetailsProps> = (props) => {
  return (
    <DetailsPage<LifePavilion,'storeLable'>
      title={'生活馆详情'}
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<LifePavilion>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>

    </DetailsPage>);
};

const mapStateToProps = ({ lifePavilion }: RootState) => ({
  entity: lifePavilion.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(LifePavilionDetails);
